<template>
  <div style="position: relative" class="bigBox">
    <div style="position: absolute; top: -7px" v-if="propertylist">
      <span
        :class="[
          color && Array.isArray(errorMessages) && errorMessages.length <= 0
            ? 'primary--text'
            : '',
        ]"
        :style="{
          'font-size': '12px',
          color:
            Array.isArray(errorMessages) && errorMessages.length > 0
              ? 'red'
              : '',
        }"
      >
        {{ label }}
      </span>
    </div>
    <v-autocomplete
      v-model="uuid"
      :readonly="readonly"
      :items="selectList"
      :placeholder="
        placeholder
          ? removestar(placeholder)
          : readonly
          ? ' '
          : removestar(label)
      "
      @change="change"
      :errorMessages="errorMessages"
      @blur="blur"
      @focus="focus"
      :label="propertylist ? '' : label"
      :multiple="multiple"
      style="min-height: 40px"
      :background-color="
        backgroundColor ? backgroundColor : readonly ? '' : '#f5f5f5'
      "
      color="primary"
      :append-icon="readonly ? arrow_drop_down : 'arrow_drop_down'"
      :filter="filterMethod"
      :item-text="itemText"
      :item-value="itemValue"
      v-bind="$attrs"
      v-on="$listeners"
    >
      <template v-slot:no-data>
        <mrc_ess_noContent
          height="50"
          type="2"
          svgFontSize="50"
          :no_data_text="$t('label_blank')"
        />
      </template>

      <template v-slot:prepend-inner>
        <div class="d-flex align-center">
          <v-chip v-for="(item, index) in propertylist" :key="index" close>
            {{ item[propertyKey] }}
          </v-chip>
        </div>
      </template>
      <template v-slot:selection="data">
        <!-- 多选 -->
        <div v-if="multiple">
          <v-chip
            v-bind="data.attrs"
            :input-value="data.selected"
            :close="!readonly"
            @click="data.select"
            @click:close="remove(data.item)"
          >
            <span style="color: rgba(0, 0, 0, 0.87)">
              {{ INT(data.item[itemText]) }}
              <v-tooltip bottom v-if="deptView">
                <template v-slot:activator="{ on, attrs }">
                  <span v-bind="attrs" v-on="on">
                    <span style="font-size: 13px; color: rgba(0, 0, 0, 0.5)"
                      >({{
                        INT(data.item[f1])
                          | replaceclient_and_org($attrs.disabled && !readonly)
                      }})</span
                    >
                  </span>
                </template>
                <span>
                  {{ INT(data.item[f1]) | replaceclient_and_org(true) }}
                </span>
              </v-tooltip>
            </span>
          </v-chip>
        </div>
        <!-- 单选 -->
        <div v-else class="d-flex align-center">
          <v-icon
            class="material-icons mr-3"
            v-if="iconView"
            style="font-size: 20px"
          >
            {{ INT(data.item[itemText]) }}
          </v-icon>
          <span style="font-size: 16px; color: rgba(0, 0, 0, 0.87)">
            {{ INT(data.item[itemText]) }}
            <v-tooltip bottom v-if="deptView">
              <template v-slot:activator="{ on, attrs }">
                <span v-bind="attrs" v-on="on">
                  <span style="font-size: 13px; color: rgba(0, 0, 0, 0.5)"
                    >({{
                      INT(data.item[f1])
                        | replaceclient_and_org($attrs.disabled && !readonly)
                    }})</span
                  >
                </span>
              </template>
              <span>
                {{ INT(data.item[f1]) | replaceclient_and_org(true) }}
              </span>
            </v-tooltip>
          </span>
        </div>
      </template>
      <!-- 下拉列表 -->
      <template v-slot:item="data">
        <template v-if="data.item != null">
          <v-list-item-content
            class="pa-0"
            style="height: 56px; border-bottom: 1px solid rgb(224, 224, 224)"
            v-if="multiple && data.item.allcheck"
          >
            <div @click.stop="allcheck" class="px-4">
              <v-checkbox
                class="pt-4"
                :label="$t('label_select_all')"
                :on-icon="
                  statusCheck == 'indeterminate'
                    ? '$checkboxIndeterminate'
                    : '$checkboxOn'
                "
                readonly
                v-model="statusCheck"
              >
              </v-checkbox>
            </div>
          </v-list-item-content>

          <div style="height: 56px" class="d-flex align-center pl-4" v-else>
            <div style="height: 56px" class="d-flex align-center">
              <v-checkbox
                class="pt-6"
                v-if="multiple && !data.item.allcheck"
                v-model="data.attrs.inputValue"
              >
              </v-checkbox>
            </div>

            <v-list-item-content v-if="deptView">
              <div class="text-body-s">
                {{ INT(data.item[itemText]) }}
              </div>
              <div
                class="text-ellipsis-2 text--secondary text-caption"
                style="line-height: 1.5 !important"
              >
                <span :title="INT(data.item[f1]) | replaceclient_and_org(true)">
                  {{ INT(data.item[f1]) | replaceclient_and_org(true) }}
                </span>
              </div>
            </v-list-item-content>

            <v-list-item-content v-else-if="positionView">
              <div class="text-body-s">
                {{ INT(data.item[itemText]) }}
              </div>
              <div
                class="text-ellipsis-2 text--secondary text-caption"
                style="line-height: 1.5 !important"
              >
                {{ INT(data.item[f1]) | replaceclient_and_org(true) }}
                <!-- {{INT(data.item[client_name])}}
              {{INT(data.item[client_name])&&INT(data.item[org_level_name])?'>':''}}
              {{INT(data.item[org_level_name])}}
              {{INT(data.item[org_level_name])&&INT(data.item[dept_name])?'>':''}}
              {{INT(data.item[dept_name])}} -->
              </div>
            </v-list-item-content>

            <v-list-item-content v-else-if="orgView">
              <div>
                <span class="text-body-s">
                  {{ INT(data.item[itemText]) }}
                </span>
                <span
                  class="overflow text--secondary text-caption"
                  v-if="data.item[f2]"
                  style="line-height: 1.5 !important"
                >
                  ({{ INT(data.item[f2]) }})
                </span>
              </div>
            </v-list-item-content>

            <v-list-item-content v-else-if="clientView">
              <div>
                <span class="text-body-s">
                  {{ INT(data.item[itemText]) }}
                </span>
                <span
                  class="overflow text--secondary text-caption"
                  v-if="data.item[f1]"
                >
                  ({{ INT(data.item[f1]) }})
                </span>
              </div>
            </v-list-item-content>

            <v-list-item-content v-else-if="moduleView">
              <div>
                <span class="text-body-s">
                  {{ INT(data.item[itemText]) }}
                </span>
                <span
                  class="overflow text--secondary text-caption"
                  v-if="data.item[f1]"
                >
                  ({{ INT(data.item[f1]) }})
                </span>
              </div>
            </v-list-item-content>

            <v-list-item-content v-else-if="postGradesView">
              <div class="text-body-s">
                <span v-if="data.item[f2]"> {{ INT(data.item[f2]) }}:</span>
                <span> {{ INT(data.item[itemText]) }}</span>
              </div>
              <div
                class="overflow text--secondary text-caption"
                v-if="data.item[f1] || data.item[f1] === 0"
              >
                {{ $t("label_The_hierarchy") }}:{{ INT(data.item[f1]) }}
              </div>
            </v-list-item-content>

            <v-list-item-content v-else-if="functionView">
              <div>
                <span class="text-body-s">
                  {{ INT(data.item[itemText]) }}
                </span>
                <span
                  class="overflow text--secondary text-caption"
                  v-if="data.item[f1]"
                  style="font-size: 14px"
                >
                  ({{ INT(data.item[f1]) }})
                </span>
              </div>
            </v-list-item-content>

            <v-list-item-content v-else-if="iconView">
              <div>
                <v-icon class="material-icons mr-3" style="font-size: 20px">
                  {{ INT(data.item[itemText]) }}
                </v-icon>

                <span class="text-body-s">
                  {{ INT(data.item[itemText]) }}
                </span>
              </div>
            </v-list-item-content>

            <v-list-item-content v-else>
              <span class="text-body-s">
                {{ INT(data.item[itemText]) }}
              </span>
            </v-list-item-content>
          </div>
        </template>
      </template>
    </v-autocomplete>
  </div>
</template>

<script>
/**
 * 参照组件
 *
 */
import iconList from "@/assets/js/mrc_ess_icon.js";
import { get_dict_name } from "@/service/api/data_dictionary";
import { getBusinessList } from "@/service/api/prompt";
export default {
  components: {},
  props: {
    arrow_drop_down: {
      type: String,
      default: "",
    },
    errorMessages: {},
    propertylist: {
      //内容前的数据
      type: Array,
    },
    propertyKey: {
      type: String,
      default: "property",
    },
    clientView: {
      //客户显示
      type: Boolean,
      default: false,
    },
    orgView: {
      //单位显示
      type: Boolean,
      default: false,
    },
    deptView: {
      //部门显示
      type: Boolean,
      default: false,
    },
    positionView: {
      //岗位显示
      type: Boolean,
      default: false,
    },
    postGradesView: {
      //岗位等级显示
      type: Boolean,
      default: false,
    },
    moduleView: {
      //模块显示
      type: Boolean,
      default: false,
    },
    functionView: {
      //功能显示
      type: Boolean,
      default: false,
    },
    iconView: {
      //图标显示
      type: Boolean,
      default: false,
    },
    label: {},
    placeholder: {},
    backgroundColor: {
      type: String,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    dropDownList: {
      type: Array,
    },
    staffUuid: {
      type: String,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    staffCode: {
      //员工id
      type: String,
      default: "staff_code",
    },
    itemText: {
      type: String,
      default: "view_fields",
    },
    itemValue: {
      type: String,
      default: "value_field",
    },
    job_post_name: {
      //岗位
      type: String,
      default: "job_post_name",
    },
    job_grade_name: {
      //岗位等级
      type: String,
      default: "job_grade_name",
    },
    client_name: {
      //客户名称
      type: String,
      default: "client_name",
    },
    org_level_name: {
      //单位名称
      type: String,
      default: "org_level_all",
    },
    dept_name: {
      //部门名称
      type: String,
      default: "dept_name",
    },
    f1: {
      //高级参照返回key
      type: String,
      default: "f1",
    },
    f2: {
      //高级参照返回key
      type: String,
      default: "f2",
    },
    staff_avatar: {
      //图片地址
      type: [String, Object],
    },
    prompt_name: {
      //高级参照请求
      type: [String, Object],
    },
    dict_name: {
      //普通参照请求
      type: [String, Object],
    },
    itemHeight: {
      type: String,
      default: "56",
    },
  },
  model: {
    prop: "staffUuid",
    event: "changeStaff",
  },
  data() {
    return {
      // '#934CEO',
      colorArr: [
        "#637A88",
        "#3F9B30",
        "#289DAA",
        "#66B4E7",
        "#4354B4",
        "#7C81FC",
        "rgb(147, 76, 14)",
        "#AA3E90",
        "#FC8282",
        "#AA3E3E",
        "#ED7217",
        "#DBB016",
      ],
      randomcolor: null,
      uuid: [],
      autoUpdate: true,
      selectList: [],
      color: false,
    };
  },
  filters: {
    replaceclient_and_org(val, all) {
      if (!val) return "";
      let max = 5,
        str = val.replace(/\//g, ">");
      if (str.split(">").length > max && !all) {
        return (
          str.split(">")[0] +
          ">" +
          str.split(">")[1] +
          ">...>" +
          str.split(">")[str.split(">").length - 2] +
          ">" +
          str.split(">")[str.split(">").length - 1]
        );
      }

      return str;
    },
  },
  computed: {
    statusCheck() {
      let uuidLength = this.staffUuid
        ? this.staffUuid.indexOf(",") != -1
          ? this.staffUuid.split(",").length
          : this.staffUuid
          ? 1
          : 0
        : 0;
      let length = this.selectList.length - 1;
      if (uuidLength == length) return true;
      else if (uuidLength > 0) return "indeterminate";
      else return false;
    },
    c_iconList() {
      let arr = iconList.map((item) => {
        return {
          view_fields: item,
          value_field: item,
        };
      });
      return arr;
    },
  },
  created() {},
  watch: {
    dropDownList: {
      handler(val) {
        if (Array.isArray(val) && val.length > 0) {
          this.selectList = val;
          if (this.selectList.length > 1 && this.multiple) {
            this.selectList = [{ allcheck: "allcheck" }, ...this.selectList];
          }
        } else {
          this.selectList = [];
        }
      },
      deep: true,
    },
    staffUuid(val) {
      if (this.multiple) {
        if (val == "" || val == undefined) return (this.uuid = []);
        val.indexOf(",") != -1
          ? (this.uuid = this.$set(this, "uuid", val.split(",")))
          : this.$set(this, "uuid", [val]);
      } else {
        this.uuid = val;
      }
    },
    prompt_name: {
      async handler(val) {
        if (val) {
          let obj = {};
          if (typeof val == "string") obj = { prompt_name: val };
          if (typeof val == "object") obj = val;
          const res = await getBusinessList({
            ...obj,
            value: this.staffUuid,
          });
          if (res.code == 200) {
            if (Array.isArray(res.data) && res.data.length > 0) {
              this.selectList = res.data;
              if (this.selectList.length > 1 && this.multiple) {
                this.selectList = [
                  { allcheck: "allcheck" },
                  ...this.selectList,
                ];
              }
            } else {
              this.selectList = [];
            }
          }
        }
      },
    },
    dict_name: {
      async handler(val) {
        if (val) {
          let obj = {};
          if (typeof val == "string") obj = { dict_name: val };
          if (typeof val == "object") obj = val;
          const res = await get_dict_name(obj);
          if (res.code == 200) {
            if (Array.isArray(res.data) && res.data.length > 0) {
              this.selectList = res.data;
              if (this.selectList.length > 1 && this.multiple) {
                this.selectList = [
                  { allcheck: "allcheck" },
                  ...this.selectList,
                ];
              }
            } else {
              this.selectList = [];
            }
          }
        }
      },
    },
  },
  async mounted() {
    if (this.multiple) {
      if (this.staffUuid != "" && this.staffUuid != undefined) {
        this.uuid =
          this.staffUuid.indexOf(",") != -1
            ? (this.uuid = this.staffUuid.split(","))
            : this.staffUuid
            ? [this.staffUuid]
            : [];
      }
    } else {
      this.uuid = this.staffUuid;
    }
    if (this.prompt_name) {
      let obj = {};
      if (typeof this.prompt_name == "string")
        obj = { prompt_name: this.prompt_name };
      if (typeof this.prompt_name == "object") obj = this.prompt_name;
      const res = await getBusinessList({
        ...obj,
        value: this.staffUuid,
      });
      if (res.code == 200) {
        if (Array.isArray(res.data) && res.data.length > 0) {
          this.selectList = res.data;
          if (this.selectList.length > 1 && this.multiple) {
            this.selectList = [{ allcheck: "allcheck" }, ...this.selectList];
          }
        } else {
          this.selectList = [];
        }
      }
    } else if (this.dict_name) {
      let obj = {};
      if (typeof this.dict_name == "string")
        obj = { dict_name: this.dict_name };
      if (typeof this.dict_name == "object") obj = this.dict_name;
      const res = await get_dict_name(obj);
      if (res.code == 200) {
        if (Array.isArray(res.data) && res.data.length > 0) {
          this.selectList = res.data;
          if (this.selectList.length > 1 && this.multiple) {
            this.selectList = [{ allcheck: "allcheck" }, ...this.selectList];
          }
        } else {
          this.selectList = [];
        }
      }
    } else {
      if (Array.isArray(this.dropDownList) && this.dropDownList.length > 0) {
        this.selectList = this.dropDownList;
        if (this.selectList.length > 1 && this.multiple) {
          this.selectList = [{ allcheck: "allcheck" }, ...this.selectList];
        }
      } else {
        this.selectList = [];
      }
    }
    if (this.iconView) {
      this.selectList = this.c_iconList;
    }
  },
  methods: {
    removestar(v) {
      return String(v).replace("*", "");
    },
    blur() {
      this.color = false;
    },
    focus() {
      this.color = true;
    },
    allcheck(val) {
      let arr = this.$clone(this.selectList);
      // console.log(this.statusCheck, !this.statusCheck);
      if (!this.statusCheck || this.statusCheck == "indeterminate") {
        let uuids = [];
        arr.splice(0, 1);
        arr.forEach((item) => {
          uuids.push(item[this.itemValue]);
        });
        this.$nextTick(() => {
          this.$emit("changeStaff", uuids.join());
          this.$emit("changeStaffList", arr);
        });
      } else {
        this.$nextTick(() => {
          this.$emit("changeStaff", "");
          this.$emit("changeStaffList", []);
        });
      }
    },
    getImgSrc(val) {
      if (typeof val == "object") return val.path;
      if (val == "" || val == undefined) return "";
      findSrc({ uuid: val }).then((res) => {
        if (res.data.files.length > 0) {
          return res.data.files[0].path;
        } else {
          return "";
        }
      });
    },
    filterMethod(item, queryText) {
      if (queryText) {
        if (!this.INT(item[this.itemText])) return false;

        const textOne = this.INT(item[this.itemText]).toLowerCase();

        const textTwo = this.INT(item[this.staffCode])
          ? this.INT(item[this.staffCode]).toLowerCase()
          : "";

        const searchText = String(queryText).toLowerCase();

        return (
          textOne.indexOf(searchText) > -1 || textTwo.indexOf(searchText) > -1
        );
      }
    },
    change(val) {
      if (this.multiple) {
        let arr = this.$clone(this.uuid);
        let arr2 = [];
        if (Array.isArray(arr) && arr.length > 0) {
          this.selectList.forEach((item) => {
            let isno = false;
            arr.forEach((item1) => {
              if (item[this.itemValue] == item1) {
                isno = true;
                return;
              }
            });
            if (isno) {
              arr2.push(item);
            }
          });
        }
        this.$emit("changeStaffList", arr2);
        this.$emit(
          "changeStaff",
          Array.isArray(this.uuid) && this.uuid.length > 0
            ? this.uuid.join()
            : ""
        );
      } else {
        this.$emit("changeStaff", val ? val : "");
        let obj = this.selectList.filter((item) => {
          return item[this.itemValue] == val;
        });
        this.$emit("changeStaffList", obj.length > 0 ? obj[0] : {});
      }
    },
    remove(item) {
      if (this.multiple) {
        const index = this.uuid.indexOf(item[this.itemValue]);
        if (index >= 0) this.uuid.splice(index, 1);
        let arr = this.$clone(this.uuid);
        let arr2 = [];
        if (Array.isArray(arr) && arr.length > 0) {
          this.selectList.forEach((item) => {
            let isno = false;
            arr.forEach((item1) => {
              if (item[this.itemValue] == item1) {
                isno = true;
                return;
              }
            });
            if (isno) {
              arr2.push(item);
            }
          });
        }
        this.$emit("changeStaffList", arr2);
        this.$emit("changeStaff", this.uuid.length > 0 ? this.uuid.join() : "");
      } else {
        this.uuid = "";
        this.$emit("changeStaff", this.uuid);
      }
    },
  },
};
</script>

<style scoped>
.v-input--selection-controls {
  margin: 0;
  padding: 0;
}
/deep/ .v-select__slot {
  min-height: 40px;
}
/deep/ .v-select__selections {
  min-height: 40px;
  padding-left: 8px;
}
/deep/ .v-list-item {
  min-height: 40px !important;
  padding: 0;
}
/deep/ .v-list-item__content {
  min-height: 40px !important;
  /* max-height: 48px !important; */
  /* padding: 7px 0; */
}
.overflow {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
.text-ellipsis-2 {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
.bigBox /deep/.v-input .v-label {
  top: 2px !important;
  /* left: -5px !important; */
}
/deep/ .v-input__append-inner {
  margin-top: 8px;
  margin-right: 8px;
}
.v-application--is-ltr .v-text-field .v-input__prepend-inner {
  padding: 0 !important;
}
</style>
